/* eslint-disable max-lines, sonarjs/cognitive-complexity */
import logger from '@tcp/core/src/utils/loggerInstance';
import constants from '@tcp/core/src/components/features/CnC/Checkout/Checkout.constants';
import {
  setSessionStorage,
  isClient,
  addRecommendationsObj,
  addBestSellerObj,
  getSessionStorage,
  removeSessionStorage,
  fireEnhancedEcomm,
  getOrderAdditionalData,
  getMetric7,
  addBossUnavailableObj,
} from '@tcp/core/src/utils';
import {
  getIsColorConsolidationEnabled,
  getAbTestIsTopRatedBadgeEnabled,
  getAbTestIsBestSellerBackAbTestEnabled,
  getAbTestIsMostFavoritedBackAbEnabled,
  getCheckoutMetricsStatus,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { getCD66Data } from '@tcp/core/src/components/features/account/BuyItAgain/container/BuyItAgain.selectors';
import BagPageUtils, {
  bossUnavailableTracking,
} from '@tcp/core/src/components/features/CnC/BagPage/views/Bagpage.utils';
import {
  getBagAnalyticsData,
  isPlccICFired,
} from '@tcp/core/src/components/features/CnC/AddedToBag/container/AddedToBag.selectors';
import { getPageData } from '@tcp/core/src/components/features/CnC/SinglePageCheckout/container/SinglePageCheckout.selector';
import { getIsBossSwitchFromCheckout } from '@tcp/core/src/components/features/CnC/CartItemTile/container/CartItemTile.selectors';
import { trackPageView, setClickAnalyticsData } from '@tcp/core/src/analytics/actions';
import { TOP_RATED, BEST_SELLER, MOST_FAVORITED } from '@tcp/core/src/constants/badge.constants';
import { put, call, select, delay, fork } from 'redux-saga/effects';
import CheckoutSelector, { isExpressCheckout } from '../../Checkout/container/Checkout.selector';
import { getCurrentCurrency } from '../../../browse/ProductDetail/container/ProductDetail.selectors';
import {
  getGrandTotal,
  getGiftCardsTotal,
} from '../../common/organism/OrderLedger/container/orderLedger.selector';
import confirmationSelector, {
  getOrderConfirmationCartItems,
} from '../../Confirmation/container/Confirmation.selectors';
import BAGPAGE_SELECTORS from '../../BagPage/container/BagPage.selectors';
import { getCD81Data } from '../../../account/BirthdayModule/container/BirthdayModule.selectors';
import pushEventToAdobeAnalytics from '../../../../../adobeAnalytics/adobe.utils';
import { setCheckoutMetricsStatus } from '../../../../../reduxStore/actions';

const HP_IN_YOUR_CART_SESSION_KEY = 'hpInYourCart';
const shopSimilarAnalyticsText = 'shop similar';
export const getConfirmationPageAdditionalData = (props) => {
  const { currentOrderId, paymentMethodId, billingAddress, orderSubTotal, itemsCount, itemsPrice } =
    props;

  return {
    orderId: currentOrderId,
    paymentMethod: paymentMethodId,
    billingZip: billingAddress && billingAddress.zipCode,
    billingCountry: billingAddress && billingAddress.country,
    orderSubtotal: orderSubTotal.toString(),
    confirmationPage: true,
    itemsPrice,
    itemsCount,
  };
};

function getSessionValue({ key }) {
  let sessionValue = {};
  try {
    if (isClient()) {
      sessionValue = JSON.parse(getSessionStorage(key));
      sessionValue = typeof sessionValue === 'object' ? JSON.stringify(sessionValue) : sessionValue;
      sessionValue = (sessionValue && sessionValue.length && JSON.parse(sessionValue)) || {};
    }
    return sessionValue;
  } catch (ex) {
    return {};
  }
}

const getOriginalPrice = ({ item, currency, hardMarkDownSV }) => {
  if (hardMarkDownSV && hardMarkDownSV[item?.partNumber]) {
    return hardMarkDownSV[item?.partNumber];
  }
  return `${item?.listPrice?.toFixed(2)} ${currency}`;
};

export const formattedProductsData = (
  props,
  currentStage,
  cd66Data = {},
  cd81Data = {},
  colorConsolidationSV = {},
  topRatedBestSellerSV = {},
  nullSearchSV = {},
  bopisFavNonFavStoreValue = {},
  atcJourneyValue = {},
  hpInYourCartJourneyValue = {},
  esgBadgesSV = {}
  // eslint-disable-next-line max-params
) => {
  const {
    cartOrderItems,
    confirmationPageLedgerSummaryData,
    shippingMethodSelected,
    orderBalanceTotal,
    giftCardTotal,
    grandTotal,
  } = props;
  const { displayName, price } = shippingMethodSelected;
  const { topRatedSV = {}, bestSellerSV = {}, mostFavSV = {} } = topRatedBestSellerSV || {};
  const isConfirmationPage =
    currentStage && currentStage.toLowerCase() === constants.CHECKOUT_STAGES.CONFIRMATION;
  const shippingMethodTitle = price > 0 ? `${displayName.toLowerCase()} - $${price}` : displayName;

  const netRevenue = giftCardTotal > 0 ? grandTotal : orderBalanceTotal;

  return BagPageUtils.formatBagProductsData(
    cartOrderItems,
    {
      shippingMethod: shippingMethodTitle,
      shippingAmount: price,
      netRevenue,
      cd66Data,
      cd81Data,
      colorConsolidationSV,
      topRatedSV,
      bestSellerSV,
      mostFavSV,
      nullSearchSV,
      esgBadgesSV,
      bopisFavNonFavStoreValue,
      atcJourneyValue,
      hpInYourCartJourneyValue,
    },
    confirmationPageLedgerSummaryData,
    isConfirmationPage
  );
};

const addBossUnavailableTracker = (productsData) => {
  return new Promise(async (resolve) => {
    try {
      productsData.forEach(async (product) => {
        const prod = product;
        const bossUnavailableObj = await bossUnavailableTracking(product.partNumber);
        if (bossUnavailableObj.dimension140) {
          prod.dimension140 = 'yes';
        }
      });
    } catch (e) {
      logger.error(e);
    }
    resolve();
  });
};

export function* getAnalyticsEvents(props, currentStage, productsDataObj) {
  const { isMobile } = props;
  const events = [];
  let isStepVisited = 0;
  const currentStageLower = currentStage?.toLowerCase();
  if (isMobile) {
    isStepVisited = yield select(getCheckoutMetricsStatus, currentStageLower);
  }
  if (currentStageLower === constants.CHECKOUT_STAGES.SHIPPING) {
    events.push('scCheckout', 'event9');
    pushEventToAdobeAnalytics('checkout_shipping', {
      productsData: productsDataObj,
      isNewSession: isStepVisited,
    });
  } else if (currentStageLower === constants?.CHECKOUT_STAGES?.PICKUP) {
    pushEventToAdobeAnalytics('checkout_pickup', {
      productsData: productsDataObj,
      isNewSession: isStepVisited,
    });
  } else if (currentStageLower === constants.CHECKOUT_STAGES.BILLING) {
    events.push('scCheckout', 'event11');
    pushEventToAdobeAnalytics('checkout_billing', {
      productsData: productsDataObj,
      isNewSession: isStepVisited,
    });
  } else if (currentStageLower === constants.CHECKOUT_STAGES.CONFIRMATION) {
    events.push('purchase', 'event5');
  } else if (currentStageLower === constants.CHECKOUT_STAGES.CONTACT_INFO) {
    events.push('scCheckout', 'event146');
  } else if (currentStageLower === constants.CHECKOUT_STAGES.REVIEW) {
    events.push('scCheckout', 'event12');
    pushEventToAdobeAnalytics('checkout_review', {
      productsData: productsDataObj,
      isNewSession: isStepVisited,
    });
  }
  if (!isMobile) {
    if (currentStage.toLowerCase() === constants.CHECKOUT_STAGES.CONFIRMATION) {
      events.push('event6', 'event7', 'event78', 'event79', 'event99', 'event2');
    } else {
      events.push('event86');
    }
  }
  if (isMobile && isStepVisited) {
    yield put(setCheckoutMetricsStatus({ [currentStageLower]: 0 }));
  }
  return events;
}

export const addMtagObj = (item, props) => {
  const { cartAnalyticsData } = props;
  let obj = {};
  const itemData = cartAnalyticsData?.find((cartItem) => {
    return cartItem.skuId === item.sku && cartItem.name.toLowerCase() === item.name.toLowerCase();
  });
  if (itemData) {
    obj = {
      dimension124: itemData.dimension124,
      dimension125: itemData.dimension125,
    };
  }
  return obj;
};

export const addPromotionObj = (item) => {
  const { priceAdjustments } = item;
  try {
    if (priceAdjustments) {
      const priceAdjustmentsParsed = JSON.parse(JSON.stringify(priceAdjustments));
      let promoText = '';
      priceAdjustmentsParsed.forEach((adjustment) => {
        const { itemText } = adjustment;
        promoText = promoText.length ? `|${itemText}` : itemText;
      });
      return {
        dimension56: promoText,
      };
    }
    return {};
  } catch (ex) {
    return {};
  }
};

export const addBackPackObj = (item) => {
  const { accessories, customizationType } = item;
  try {
    if (accessories) {
      const parsedAccessories = JSON.parse(JSON.stringify(accessories));
      return {
        dimension11: `${customizationType}|${parsedAccessories?.length}`,
      };
    }
    return {};
  } catch (ex) {
    return {};
  }
};

const checkIfSyteProduct = (item, syteProductsAdded) => {
  return syteProductsAdded?.includes(item?.partNumber) || !item?.partNumber;
};

export const getConfirmationPageArgsNormal = (
  commonData,
  productsData,
  dataLayer,
  cartTypes,
  props,
  isCvvSuppressed
) => {
  const {
    currentOrderId,
    paymentMethodId,
    currency,
    confirmationPageLedgerSummaryData,
    grandTotal,
    billingAddress,
    orderConfirmation,
  } = props;
  let orderData = {};
  const { zipCode = '', country = '' } = billingAddress || {};
  orderData.actionField = {
    id: currentOrderId,
    revenue: grandTotal,
    tax: confirmationPageLedgerSummaryData?.taxesTotal,
    shipping: confirmationPageLedgerSummaryData?.shippingTotal,
    coupon: dataLayer && dataLayer.couponCode,
    shippingAmount: confirmationPageLedgerSummaryData?.shippingTotal,
    giftCardAmount: confirmationPageLedgerSummaryData?.giftCardsTotal,
    taxAmount: confirmationPageLedgerSummaryData?.taxesTotal,
    promotionAmount: confirmationPageLedgerSummaryData?.savingsTotal,
    metric6: confirmationPageLedgerSummaryData?.giftCardsTotal,
    metric7: `${confirmationPageLedgerSummaryData?.couponsTotal || 0} ${currency}`,
    metric22: confirmationPageLedgerSummaryData?.savingsTotal,
    metric78: confirmationPageLedgerSummaryData?.shippingTotal,
    metric79: confirmationPageLedgerSummaryData?.taxesTotal,
    metric99: confirmationPageLedgerSummaryData?.grandTotal,
    dimension4: paymentMethodId,
    dimension86: cartTypes,
    dimension73: confirmationPageLedgerSummaryData?.grandTotal,
    dimension98: dataLayer && dataLayer.checkoutType,
    dimension68: zipCode,
    dimension9: country,
    dimension3: currentOrderId,
    dimension6: dataLayer && dataLayer.couponCode,
    dimension79: confirmationPageLedgerSummaryData?.grandTotal,
    eVar141: isCvvSuppressed ? 'yes' : 'no',
    shippingZip: orderConfirmation?.shipments[0]?.shippingAddress?.postalCode || zipCode || '',
    billingZip: orderConfirmation?.billing?.postalCode || zipCode || '',
  };
  const syteProductsInBag = isClient() && getSessionStorage('syteProductsInBag');
  if (syteProductsInBag && isClient()) {
    setSessionStorage({
      key: 'syteProductsInBag',
      value: '',
    });
  }
  const hardMarkDownSV = getSessionValue({ key: 'hardPriceMarkDown' }) || {};

  orderData.productsObj =
    productsData &&
    productsData.map((item) => {
      const cd66 = item?.dimension66;
      const cd81 = item?.dimension81;
      const cd158 = item?.dimension158;
      const prodDataObj = {
        id: item.partNumber,
        variant: item.color,
        brand: item.prodBrand,
        quantity: item.quantity,
        price: item.price,
        dimension5: item.shippingMethod,
        dimension35: item.prodBrand,
        dimension53: item.storeId,
        dimension63: `${item?.price?.toFixed(2)} ${currency}: ${getOriginalPrice({
          item,
          currency,
          hardMarkDownSV,
        })}`,
        dimension77: item.color,
        dimension88: item.size,
        dimension89: item.partNumber,
        dimension57: dataLayer && dataLayer.giftType,
        dimension66: cd66,
        dimension81: cd81,
        dimension158: cd158,
        dimension108: item?.dimension108,
        dimension109: item?.dimension109,
        dimension122: item?.dimension122,
        dimension2: item?.dimension2,
        dimension130: item?.dimension130,
        dimension135: item?.dimension135,
        dimension139: item?.dimension139,
        dimension101:
          item.quantity && checkIfSyteProduct(item, syteProductsInBag)
            ? shopSimilarAnalyticsText
            : '',
        ...addBestSellerObj(item.partNumber),
        ...addRecommendationsObj(item.partNumber),
        ...addBossUnavailableObj(item.partNumber),
        ...addMtagObj(item, props),
        ...addPromotionObj(item),
        ...addBackPackObj(item),
      };
      delete prodDataObj.dimension87;
      return prodDataObj;
    });
  orderData = { ...commonData, ...orderData };
  return orderData;
};

const getConfirmationPageArgsMix = (
  commonData,
  productsData,
  dataLayer,
  cartTypes,
  props,
  isCvvSuppressed
) => {
  const { paymentMethodId, currency, billingAddress, mixOrderDetails, orderConfirmation } = props;

  const { zipCode = '', country = '' } = billingAddress || {};
  const orders = [];
  let bopisOrder = {};
  let normalOrder = {};
  mixOrderDetails.forEach((orderData) => {
    const shippingMethod = (orderData.shippingMethod && orderData.shippingMethod.name) || '';
    const shippingAmount = (orderData.shippingMethod && orderData.shippingMethod.price) || 0;
    const order = {
      actionField: {
        id: orderData.c_orderNo,
        revenue: orderData.shipmentTotal,
        tax: orderData.totalTax,
        shipping: shippingMethod,
        coupon: dataLayer && dataLayer.couponCode,
        shippingAmount,
        giftCardAmount: 0,
        taxAmount: orderData.totalTax,
        promotionAmount: 0,
        metric6: 0,
        metric7: 0,
        metric22: 0,
        metric78: shippingAmount,
        metric79: orderData.totalTax,
        metric99: orderData.shipmentTotal,
        dimension4: paymentMethodId,
        dimension86: `${cartTypes} | ${shippingMethod}`,
        dimension73: orderData.shipmentTotal,
        dimension98: dataLayer && dataLayer.checkoutType,
        dimension68: zipCode,
        dimension9: country,
        dimension3: orderData.c_orderNo,
        dimension6: dataLayer && dataLayer.couponCode,
        dimension79: orderData.shipmentTotal,
        eVar141: isCvvSuppressed ? 'yes' : 'no',
        shippingZip: orderConfirmation?.shipments[0]?.shippingAddress?.postalCode || zipCode || '',
        billingZip: orderConfirmation?.billing?.postalCode || zipCode || '',
      },
    };
    if (shippingMethod === 'BOSS' || shippingMethod === 'BOPIS') {
      bopisOrder = order;
    } else {
      normalOrder = order;
    }
  });

  bopisOrder = { ...commonData, ...bopisOrder };
  normalOrder = { ...commonData, ...normalOrder };

  const bopisProducts = [];
  const normalProducts = [];
  const syteProductsInBag = isClient() && getSessionStorage('syteProductsInBag');
  if (syteProductsInBag && isClient()) {
    setSessionStorage({
      key: 'syteProductsInBag',
      value: '',
    });
  }

  const hardMarkDownSV = getSessionValue({ key: 'hardPriceMarkDown' }) || {};

  productsData.forEach((item) => {
    const cd66 = item?.dimension66;
    const cd81 = item?.dimension81;
    const cd158 = item?.dimension158;
    const productData = {
      id: item.partNumber,
      variant: item.color,
      brand: item.prodBrand,
      quantity: item.quantity,
      price: item.price,
      dimension5: item.shippingMethod,
      dimension35: item.prodBrand,
      dimension53: item.storeId,
      dimension63: `${item?.price?.toFixed(2)} ${currency}: ${getOriginalPrice({
        item,
        currency,
        hardMarkDownSV,
      })}`,
      dimension77: item.color,
      dimension88: item.size,
      dimension89: item.partNumber,
      dimension57: dataLayer && dataLayer.giftType,
      dimension66: cd66,
      dimension81: cd81,
      dimension158: cd158,
      dimension108: item?.dimension108,
      dimension109: item?.dimension109,
      dimension122: item?.dimension122,
      dimension2: item?.dimension2,
      dimension130: item?.dimension130,
      dimension135: item?.dimension135,
      dimension139: item?.dimension139,
      dimension101:
        item.quantity && checkIfSyteProduct(item, syteProductsInBag)
          ? shopSimilarAnalyticsText
          : '',
      ...addBestSellerObj(item.partNumber),
      ...addRecommendationsObj(item.partNumber),
      ...addBossUnavailableObj(item.partNumber),
      ...addMtagObj(item, props),
      ...addPromotionObj(item),
      ...addBackPackObj(item),
    };
    delete productData.dimension87;

    if (item.storeId) {
      if (bopisOrder && bopisOrder.actionField) {
        bopisOrder.actionField = {
          ...bopisOrder.actionField,
          ...getOrderAdditionalData(bopisOrder.actionField, item),
        };
      }
      bopisProducts.push(productData);
    } else {
      if (normalOrder && normalOrder.actionField) {
        normalOrder.actionField = {
          ...normalOrder.actionField,
          ...getOrderAdditionalData(normalOrder.actionField, item),
        };
      }
      normalProducts.push(productData);
    }
  });
  bopisOrder.productsObj = bopisProducts;
  normalOrder.productsObj = normalProducts;
  bopisOrder.actionField = {
    ...bopisOrder.actionField,
    ...getMetric7(bopisOrder, currency),
  };
  normalOrder.actionField = {
    ...normalOrder.actionField,
    ...getMetric7(normalOrder, currency),
  };

  orders.push(bopisOrder);
  orders.push(normalOrder);
  return orders;
};

const getBossSwitchStr = (isExpressCheckoutEnabled) => {
  let str = 'boss|checkout switch';
  if (isExpressCheckoutEnabled) {
    str = 'boss|checkout switch|Instant Checkout';
  }
  return str;
};

const getConfirmationPageArgs = (
  props,
  productsData,
  dataLayer,
  isFiredFromPLCC,
  isExpressCheckoutEnabled,
  isFromBossSwitch,
  isCvvSuppressed
) => {
  const { currency, afterPayPaymentProgress } = props;

  const args = {
    eventName: 'purchases',
    eventAction: 'Purchase',
    eventLabel: 'Purchase',
    currCode: currency,
    eventType: 'purchase',
  };
  let data = [];
  const uniqueCartTypes = new Set(
    productsData.map((el) => {
      if (!el.orderItemType || el.orderItemType === 'ECOM') return 'standard';
      return el.orderItemType.toLowerCase();
    })
  );
  const instantCheckoutConstant = 'Instant Checkout';

  let cartTypes = uniqueCartTypes && uniqueCartTypes.size && Array.from(uniqueCartTypes).join('|');
  if (isFromBossSwitch) {
    cartTypes = getBossSwitchStr(isExpressCheckoutEnabled);
  }
  if (isFiredFromPLCC || afterPayPaymentProgress) {
    cartTypes = cartTypes?.concat('|', instantCheckoutConstant);
  }
  if (uniqueCartTypes && uniqueCartTypes.size > 1) {
    cartTypes = 'mix';
    if (isFiredFromPLCC || afterPayPaymentProgress) {
      cartTypes = cartTypes?.concat('|', instantCheckoutConstant);
    }
    data = getConfirmationPageArgsMix(
      args,
      productsData,
      dataLayer,
      cartTypes,
      props,
      isCvvSuppressed
    );
  } else {
    data = [
      getConfirmationPageArgsNormal(
        args,
        productsData,
        dataLayer,
        cartTypes,
        props,
        isCvvSuppressed
      ),
    ];
  }
  return data;
};

const getShouldCMEventsFire = (analyticsObj, currentStage) => {
  if (currentStage.toLowerCase() === constants.CHECKOUT_STAGES.PICKUP) {
    const { metric14 = false } = analyticsObj || {};
    if (!metric14) {
      setSessionStorage({
        key: 'AnalyticsObj',
        value: JSON.stringify({ ...analyticsObj, metric14: true }),
      });
      return true;
    }
    return false;
  }
  if (currentStage.toLowerCase() === constants.CHECKOUT_STAGES.BILLING) {
    const { metric11 = false } = analyticsObj || {};
    if (!metric11) {
      setSessionStorage({
        key: 'AnalyticsObj',
        value: JSON.stringify({ ...analyticsObj, metric11: true }),
      });
      return true;
    }
    return false;
  }
  const { metric12 = false } = analyticsObj || {};
  if (!metric12) {
    setSessionStorage({
      key: 'AnalyticsObj',
      value: JSON.stringify({ ...analyticsObj, metric12: true }),
    });
    return true;
  }
  return false;
};

export const shouldCMEventsFire = (currentStage) => {
  let analyticSV = getSessionStorage('AnalyticsObj');
  analyticSV = typeof analyticSV === 'object' ? JSON.stringify(analyticSV) : analyticSV;
  const analyticsObj = (analyticSV && analyticSV.length && JSON.parse(analyticSV)) || {};
  if (currentStage.toLowerCase() === constants.CHECKOUT_STAGES.CONTACT_INFO) {
    const { metric146 = false } = analyticsObj || {};
    if (!metric146) {
      setSessionStorage({
        key: 'AnalyticsObj',
        value: JSON.stringify({ ...analyticsObj, metric146: true }),
      });
      return true;
    }
    return false;
  }

  if (currentStage.toLowerCase() === constants.CHECKOUT_STAGES.SHIPPING) {
    const { metric9 = false } = analyticsObj || {};
    if (!metric9) {
      setSessionStorage({
        key: 'AnalyticsObj',
        value: JSON.stringify({ ...analyticsObj, metric9: true }),
      });
      return true;
    }
    return false;
  }
  return getShouldCMEventsFire(analyticsObj, currentStage);
};

export const getStepMetrics = (currentStage) => {
  const shouldEventFire = shouldCMEventsFire(currentStage);
  if (shouldEventFire) {
    if (currentStage.toLowerCase() === constants.CHECKOUT_STAGES.CONTACT_INFO)
      return { cm9: '0', cm11: '0', cm12: '0', cm146: '1', cm14: '0' };
    if (currentStage.toLowerCase() === constants.CHECKOUT_STAGES.SHIPPING)
      return { cm9: '1', cm11: '0', cm12: '0', cm146: '0', cm14: '0' };
    if (currentStage.toLowerCase() === constants.CHECKOUT_STAGES.PICKUP)
      return { cm9: '0', cm11: '0', cm12: '0', cm146: '0', cm14: '1' };
    if (currentStage.toLowerCase() === constants.CHECKOUT_STAGES.BILLING)
      return { cm9: '0', cm11: '1', cm12: '0', cm146: '0', cm14: '0' };
    if (currentStage.toLowerCase() === constants.CHECKOUT_STAGES.REVIEW)
      return { cm9: '0', cm11: '0', cm12: '1', cm146: '0', cm14: '0' };
  }
  return null;
};

export const getStepForAnalyticsForV2 = (eventLabel) => {
  let step = 1;
  if (eventLabel.toLowerCase() === constants.CHECKOUT_STAGES.SHIPPING) step = 1;
  else if (eventLabel.toLowerCase() === constants.CHECKOUT_STAGES.BILLING) step = 2;
  else if (eventLabel.toLowerCase() === constants.CHECKOUT_STAGES.REVIEW) step = 3;
  else if (eventLabel.toLowerCase() === constants.CHECKOUT_STAGES.PICKUP) step = 4;
  return step;
};

export const getStepForAnalytics = (eventLabel) => {
  let step = 1;
  if (eventLabel.toLowerCase() === constants.CHECKOUT_STAGES.CONTACT_INFO) step = 1;
  else if (eventLabel.toLowerCase() === constants.CHECKOUT_STAGES.SHIPPING) step = 2;
  else if (eventLabel.toLowerCase() === constants.CHECKOUT_STAGES.BILLING) step = 3;
  else if (eventLabel.toLowerCase() === constants.CHECKOUT_STAGES.REVIEW) step = 4;
  else if (eventLabel.toLowerCase() === constants.CHECKOUT_STAGES.PICKUP) step = 5;
  return step;
};

export const getShipBillReviewArgs = (
  products,
  dataLayer,
  currentStage,
  isLoginV2Enabled,
  props
) => {
  if (!products) return null;
  const { currency } = props;
  let stepAnalytics = 1;
  if (isLoginV2Enabled) stepAnalytics = getStepForAnalyticsForV2(currentStage);
  else stepAnalytics = getStepForAnalytics(currentStage);
  const args = {
    eventName: 'checkout',
    eventAction: 'Checkout',
    eventLabel: currentStage,
    eventType: 'checkout',
    ...getStepMetrics(currentStage),
    step: stepAnalytics,
    productsObj: [],
  };
  const syteProductsInBag = isClient() && getSessionStorage('syteProductsInBag');

  const hardMarkDownSV = getSessionValue({ key: 'hardPriceMarkDown' }) || {};

  args.productsObj = products.map((item) => {
    const cd66 = item?.dimension66;
    const cd81 = item?.dimension81;
    const cd158 = item?.dimension158;
    return {
      id: item.partNumber,
      price: item.price.toFixed(2),
      brand: item.prodBrand,
      category: '',
      variant: item.color,
      quantity: item.quantity,
      dimension35: item.prodBrand,
      dimension63: `${item.price.toFixed(2)} ${currency}: ${getOriginalPrice({
        item,
        currency,
        hardMarkDownSV,
      })}`,
      dimension66: cd66,
      dimension81: cd81,
      dimension77: item.color,
      dimension82: item.upc,
      dimension67: item.price < item.listPrice ? 'on sale' : 'full price',
      dimension88: item.size,
      dimension89: item.partNumber,
      dimension95: item.sku,
      dimension98: dataLayer && dataLayer.checkoutType,
      dimension158: cd158,
      dimension108: item?.dimension108,
      dimension109: item?.dimension109,
      dimension122: item?.dimension122,
      dimension2: item?.dimension2,
      dimension130: item?.dimension130,
      dimension135: item?.dimension135,
      dimension139: item?.dimension139,
      dimension101:
        products.quantity && checkIfSyteProduct(item, syteProductsInBag)
          ? shopSimilarAnalyticsText
          : '',
      ...addBestSellerObj(item.partNumber),
      ...addRecommendationsObj(item.partNumber),
      ...addBossUnavailableObj(item.partNumber),
      ...addMtagObj(item, props),
      ...addPromotionObj(item),
      ...addBackPackObj(item),
    };
  });
  return args;
};
const getProductData = (args, props) => {
  return args?.productsObj?.map((obj) => {
    const match = props?.orderConfirmation?.orderItems?.find(
      (item) => item?.productInfo?.productPartNumber === obj?.id
    );
    const newObj = { ...obj };
    if (match && obj) {
      newObj.productUID = match?.productInfo?.upc;
    }
    return newObj;
  });
};
export const updateGoogleAnalyticsData = (
  props,
  currentStage,
  isLoginV2Enabled,
  cd66Data = {},
  cd81Data = {},
  isFiredFromPLCC = false,
  {
    colorConsolidationSV = {},
    topRatedBestSellerSV = {},
    nullSearchSV = {},
    bopisFavNonFavStoreValue = {},
    esgBadgesSV = {},
    isExpressCheckoutEnabled = false,
    isFromBossSwitch = false,
    isCvvSuppressed = false,
  } = {}
) => {
  const atcJourneyValue = getSessionValue({ key: 'oneClickAtcJourney' }) || {};
  const hpInYourCartJourneyValue = getSessionValue({ key: HP_IN_YOUR_CART_SESSION_KEY }) || {};
  const isConfirmationPage = currentStage.toLowerCase() === constants.CHECKOUT_STAGES.CONFIRMATION;
  const productsData = formattedProductsData(
    props,
    currentStage,
    cd66Data,
    cd81Data,
    colorConsolidationSV,
    topRatedBestSellerSV,
    nullSearchSV,
    bopisFavNonFavStoreValue,
    atcJourneyValue,
    hpInYourCartJourneyValue,
    esgBadgesSV
  );
  let args = {};
  const { _dataLayer: dataLayer = {} } = window || {};
  try {
    if (isConfirmationPage) {
      args = getConfirmationPageArgs(
        props,
        productsData,
        dataLayer,
        isFiredFromPLCC,
        isExpressCheckoutEnabled,
        isFromBossSwitch,
        isCvvSuppressed
      );
    } else {
      args = getShipBillReviewArgs(productsData, dataLayer, currentStage, isLoginV2Enabled, props);
    }
  } catch (ex) {
    logger.error({
      error: ex,
      extraData: {
        componentName: 'CheckoutCommonContainer',
        methodName: 'updateGoogleAnalyticsData',
        checkoutStage: currentStage,
      },
    });
  }
  if (Object.keys(args).length) {
    args.isLoginV2Enabled = isLoginV2Enabled;

    if (isConfirmationPage) {
      const paymentMethods = [
        ...new Set(
          props?.orderConfirmation?.paymentsList?.map((item) =>
            item?.afterpay ? 'afterPay' : item?.paymentMethod
          )
        ),
      ];
      const payment = paymentMethods.join(',');
      const productObj = getProductData(args?.[0], props);
      if (args?.[0]) {
        args[0].actionField.payment = payment;
        args[0].productsObj = productObj;
      }
      pushEventToAdobeAnalytics('purchase', args?.[0]);
      if (args.length > 1) {
        const productObj2 = getProductData(args?.[1], props);
        if (args?.[1]) {
          args[1].actionField.payment = payment;
          args[1].productsObj = productObj2;
        }
        pushEventToAdobeAnalytics('purchase_1', args?.[1]);
      }
    }
    fireEnhancedEcomm(args);
  }
};

export function* fireAnalyticsEvents({
  props,
  currentStage,
  isPageViewRequired,
  isLoginV2Enabled,
  colorConsolidationSV = {},
  topRatedBestSellerSV = {},
  nullSearchSV = {},
  bopisFavNonFavStoreValue = {},
  esgBadgesSV = {},
}) {
  const { CHECKOUT_PAGE } = constants;
  const pageDetails = {
    pageName: `${CHECKOUT_PAGE}:${currentStage.toLowerCase()}`,
    pageSection: CHECKOUT_PAGE,
    pageSubSection: CHECKOUT_PAGE,
    pageType: CHECKOUT_PAGE,
    pageShortName: `${CHECKOUT_PAGE}:${currentStage.toLowerCase()}`,
  };
  const currState = yield select();
  if (isPageViewRequired) {
    yield delay(500);
    yield put(
      trackPageView({
        props: {
          initialProps: {
            pageProps: {
              currentScreen: currentStage.toLowerCase(),
              pageData: { ...pageDetails },
            },
          },
        },
      })
    );
    const APIConfig = {
      storeId: currState?.APIConfig?.storeId,
      brandId: currState?.APIConfig?.brandId,
      language: currState?.APIConfig?.language,
      country: currState?.APIConfig?.countryKey,
    };
    const session = {
      language: currState?.session?.siteDetails?.language,
      country: currState?.session?.siteDetails?.country,
    };
    pushEventToAdobeAnalytics('page_view', {
      APIConfig,
      session,
      User: currState?.User,
      pageData: {
        pageName: `${CHECKOUT_PAGE}:${currentStage.toLowerCase()}`,
        pageSection: CHECKOUT_PAGE,
        pageSubSection: CHECKOUT_PAGE,
        pageSubSection2: '',
        pageType: CHECKOUT_PAGE,
        pageShortName: `${CHECKOUT_PAGE}:${currentStage.toLowerCase()}`,
      },
    });
  } else {
    yield put(setClickAnalyticsData({ ...pageDetails }));
  }
  const cd66Data = yield select(getCD66Data) || '';
  const cd81Data = yield select(getCD81Data) || '';
  const isFiredFromPLCC = yield select(isPlccICFired);
  const isExpressCheckoutEnabled = yield select(isExpressCheckout);
  const isFromBossSwitch = yield select(getIsBossSwitchFromCheckout);
  const isCvvSuppressed = JSON.parse(getSessionStorage('isCvvSuppressed')) || false;
  updateGoogleAnalyticsData(
    props,
    currentStage,
    isLoginV2Enabled,
    cd66Data,
    cd81Data,
    isFiredFromPLCC,
    {
      colorConsolidationSV,
      topRatedBestSellerSV,
      nullSearchSV,
      bopisFavNonFavStoreValue,
      esgBadgesSV,
      isExpressCheckoutEnabled,
      isFromBossSwitch,
      isCvvSuppressed,
    }
  );
}

export function* startCheckoutAnalyticsData() {
  const orderBalace = yield select(getGrandTotal);
  const giftCardsTotal = yield select(getGiftCardsTotal);
  const orderBalanceTotal = orderBalace - giftCardsTotal;
  const confirmationOrderItems = yield select(getOrderConfirmationCartItems);
  const orderItems = yield select(BAGPAGE_SELECTORS.getOrderItems);
  return {
    pageData: yield select(getPageData),
    shippingMethodSelected: yield select(CheckoutSelector.getSelectedShippingMethodDetails),
    cartOrderItems: orderItems?.size > 0 ? orderItems : confirmationOrderItems,
    currentOrderId: yield select(CheckoutSelector.getCurrentOrderId),
    paymentMethodId: yield select(BAGPAGE_SELECTORS.getBillingPaymentMethod),
    billingAddress: yield select(CheckoutSelector.getBillingAddressFields),
    orderSubTotal: yield select(BAGPAGE_SELECTORS.getOrderSubTotal),
    confirmationPageLedgerSummaryData: yield select(
      confirmationSelector.getLedgerSummaryDataConfirmation
    ),
    cartAnalyticsData: yield select(getBagAnalyticsData),
    orderBalanceTotal,
    grandTotal: yield select(getGrandTotal),
    giftCardTotal: yield select(getGiftCardsTotal),
    isMobile: yield select(CheckoutSelector.getIsMobile),
    currency: yield select(getCurrentCurrency),
    mixOrderDetails: yield select(confirmationSelector.getAllShipments),
    itemsCount: yield select(confirmationSelector.getItemsCount),
    itemsPrice: yield select(confirmationSelector.getSubTotal),
    orderNumber: yield select(confirmationSelector.getCsthOrderNo),
    orderNoArray: yield select(confirmationSelector.getOrderNoArray),
    afterPayPaymentProgress: yield select(CheckoutSelector.getIsAfterPayPaymentProgress),
    cartType: yield select(confirmationSelector?.getCartType),
    orderConfirmation: yield select(confirmationSelector.getOrderConfirmation),
  };
}

function getColorConsolidationSV({ isColorConsolidationEnabled }) {
  let colorConsolidationSV = {};
  if (isClient() && isColorConsolidationEnabled) {
    colorConsolidationSV = JSON.parse(getSessionStorage('colorConsolidation'));
    colorConsolidationSV =
      typeof colorConsolidationSV === 'object'
        ? JSON.stringify(colorConsolidationSV)
        : colorConsolidationSV;
    colorConsolidationSV =
      (colorConsolidationSV && colorConsolidationSV.length && JSON.parse(colorConsolidationSV)) ||
      {};
  }
  return colorConsolidationSV;
}

function getTopRatedBestSellerSV({ backAB, value }) {
  let topRatedBestSellerSV = {};
  try {
    if (isClient() && !backAB) {
      topRatedBestSellerSV = JSON.parse(getSessionStorage(value));
      topRatedBestSellerSV =
        typeof topRatedBestSellerSV === 'object'
          ? JSON.stringify(topRatedBestSellerSV)
          : topRatedBestSellerSV;
      topRatedBestSellerSV =
        (topRatedBestSellerSV && topRatedBestSellerSV.length && JSON.parse(topRatedBestSellerSV)) ||
        {};
    }
    return topRatedBestSellerSV;
  } catch (ex) {
    return {};
  }
}

/* eslint-disable complexity */
function* startCheckoutAnalytics(currentStage, isPageViewRequired, isLoginV2Enabled) {
  if (currentStage) {
    try {
      const isColorConsolidationEnabled = yield select(getIsColorConsolidationEnabled);
      const isTopRatedBackAbEnabled = yield select(getAbTestIsTopRatedBadgeEnabled);
      const isBestSellerBackAbEnabled = yield select(getAbTestIsBestSellerBackAbTestEnabled);
      const isMostFavoritedBadgeEnabled = yield select(getAbTestIsMostFavoritedBackAbEnabled);
      const colorConsolidationSV = getColorConsolidationSV({ isColorConsolidationEnabled }) || {};
      const topRatedSV =
        getTopRatedBestSellerSV({ backAB: isTopRatedBackAbEnabled, value: TOP_RATED }) || {};
      const bestSellerSV =
        getTopRatedBestSellerSV({ backAB: isBestSellerBackAbEnabled, value: BEST_SELLER }) || {};
      const mostFavSV =
        getTopRatedBestSellerSV({ backAB: isMostFavoritedBadgeEnabled, value: MOST_FAVORITED }) ||
        {};
      const topRatedBestSellerSV = { topRatedSV, bestSellerSV, mostFavSV };
      const nullSearchSV = getSessionValue({ key: 'nullSearch' });
      const esgBadgesSV = getSessionValue({ key: 'esgBadges' });
      const bopisFavNonFavStoreValue = getSessionValue({ key: 'bopisFavorNonFavStore' });
      const atcJourneyValue = getSessionValue({ key: 'oneClickAtcJourney' });
      const hpInYourCartJourneyValue = getSessionValue({ key: HP_IN_YOUR_CART_SESSION_KEY }) || {};
      const props = yield call(startCheckoutAnalyticsData);
      const cd66Data = yield select(getCD66Data) || '';
      const cd81Data = yield select(getCD81Data) || '';
      const isConfirmationPage =
        currentStage.toLowerCase() === constants.CHECKOUT_STAGES.CONFIRMATION;
      let additionalData;
      /** This additional data only on order confirmation load event */
      const productsData = formattedProductsData(
        props,
        currentStage,
        cd66Data,
        cd81Data,
        colorConsolidationSV,
        topRatedBestSellerSV,
        nullSearchSV,
        bopisFavNonFavStoreValue,
        atcJourneyValue,
        hpInYourCartJourneyValue,
        esgBadgesSV
      );

      if (isConfirmationPage) {
        additionalData = getConfirmationPageAdditionalData(props);
        const keysToBeCleared = ['oneClickAtcJourney', 'bopisFavorNonFavStore'];
        keysToBeCleared.forEach((key) => {
          removeSessionStorage(key);
        });
      }
      yield call(addBossUnavailableTracker, productsData);
      const productsDataObj = productsData.map((item) => {
        return {
          ...item,
          ...addMtagObj(item, props),
          ...addPromotionObj(item),
          ...addBackPackObj(item),
        };
      });
      const events = yield fork(getAnalyticsEvents, props, currentStage, productsDataObj);

      const analyticsData = {
        customEvents: events,
        products: productsDataObj,
        clickEvent: true,
        ...additionalData,
      };
      yield put(setClickAnalyticsData(analyticsData));
      yield call(fireAnalyticsEvents, {
        props,
        currentStage,
        isPageViewRequired,
        isLoginV2Enabled,
        colorConsolidationSV,
        topRatedBestSellerSV,
        nullSearchSV,
        bopisFavNonFavStoreValue,
        esgBadgesSV,
      });
      yield put(setClickAnalyticsData({}));

      if (isConfirmationPage) {
        removeSessionStorage('esgBadges');
        removeSessionStorage('hardPriceMarkDown');
        removeSessionStorage('bossUnavailableItems');
        removeSessionStorage('isCvvSuppressed');
      }
    } catch (err) {
      logger.error(err);
    }
  }
  return null;
}

export default startCheckoutAnalytics;
